import { Messages } from '../../../../codegen/Localize';
import { discardDraftRequestedAction } from '../../../../drafts/actions/DiscardDraftAction';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames,IEntityAction } from './IEntityAction';


export const DiscardDraftEntityAction: IEntityAction<IContentInfo<'workbook'>, {}> = {
    name: EntityActionNames.DiscardDraft,
    translateName: Messages.discardChanges,
    isVisible: (targetItems: IContentInfo[]) => !!(targetItems[0].draftLuid),
    isClickable: (availableActions: any, targetItems: IContentInfo[]) => !!(targetItems[0].draftLuid),
    createReduxAction: (targetItems: IContentInfo[]) => {
        return discardDraftRequestedAction({
            draftLuid: targetItems[0].draftLuid,
            contentType: targetItems[0].contentType,
            parentLuid: targetItems[0].luid,
            name: targetItems[0].name,
            locationOrigin: 'ActionMenu_DiscardChanges'
        });
    }
};
